(() => {
  const selectors = {
    accordionHeader: '.js-content-faq__item-header',
    accordionItem: '.js-content-faq__item',
    accordionContent: '.content-faq__item-content',
    tab: '.js-bundle-parts__item-header-item',
    tabContent: '.bundle-parts__item-content',
    bundleItem: '.bundle-parts__item',

    accordionDescriptionClass: 'content-faq__item-content-description',
    accordionItemActiveClass: 'content-faq__item--active',
    tabActiveClass: 'bundle-parts__item-header-item--active',
    tabContentActiveClass: 'bundle-parts__item-content--active'
  }

  const toggleAccordion = (event) => {
    const item = event.currentTarget;
    const itemContent = item.querySelector(selectors.accordionContent);

    if (item.classList.contains(selectors.accordionItemActiveClass)) {
      item.classList.remove(selectors.accordionItemActiveClass);
      itemContent.style.height = '0';
    } else {
      item.classList.add(selectors.accordionItemActiveClass);
      itemContent.style.height = `${itemContent.scrollHeight}px`;
    }
  };

  const toogleTab = (event) => {
    const currentTab = event.currentTarget;

    if (currentTab.classList.contains(selectors.tabActiveClass)) return;

    const currentItem = currentTab.closest(selectors.bundleItem);
    const currentActiveTab = currentItem.querySelector(`.${selectors.tabActiveClass}`);
    const currentActiveContent = currentItem.querySelector(`.${selectors.tabContentActiveClass}`);
    const currentContent = currentItem.querySelector(`${selectors.tabContent}[data-content="${currentTab.dataset.tabContent}"]`);

    currentActiveTab?.classList.remove(selectors.tabActiveClass);
    currentActiveContent?.classList.remove(selectors.tabContentActiveClass);
    currentTab?.classList.add(selectors.tabActiveClass);
    currentContent?.classList.add(selectors.tabContentActiveClass);
  };

  const initListener = () => {
    const accordionArray = document.querySelectorAll(selectors.accordionItem);
    const tabArray = document.querySelectorAll(selectors.tab);

    accordionArray.forEach(accordion => {
      accordion.addEventListener('click', (event) => {
        if (!event.target.classList.contains(selectors.accordionDescriptionClass)) {
          toggleAccordion(event);
        }
      });
    });

    tabArray.forEach(tab => {tab.addEventListener('click', toogleTab)});
  };

  initListener();
})();
